import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, eur, errMsg } from "@/lib/api";

const input = "h-10 w-full rounded-lg border border-white/10 bg-white/5 px-3 text-sm outline-none focus:border-[#0066FF]";
const BADGE = { attivo: "bg-emerald-500/15 text-emerald-300", utilizzato: "bg-slate-500/20 text-slate-300", scaduto: "bg-amber-500/15 text-amber-300", disattivato: "bg-red-500/15 text-red-300" };
const EMPTY = { code: "", value: "", order_number: "", customer_email: "", expires_at: "", conditions: "", partial_use: false };

export default function AdminCoupons() {
  const [list, setList] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = () => api.get("/admin/coupons").then((r) => setList(r.data));
  useEffect(() => {
    load();
  }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/coupons", { ...f, value: Number(f.value), expires_at: f.expires_at ? `${f.expires_at}T23:59:59+00:00` : null });
      toast.success("Coupon creato");
      setF(EMPTY);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const act = async (fn, ok) => {
    try {
      await fn();
      toast.success(ok);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="max-w-6xl" data-testid="admin-coupons-page">
      <h1 className="font-display text-3xl font-semibold">Coupon LEONTECH</h1>
      <p className="mt-2 text-sm text-amber-200/90">Il coupon è un beneficio commerciale concordato con il cliente: non sostituisce mai automaticamente un rimborso dovuto per legge.</p>
      <form onSubmit={create} className="mt-6 grid gap-3 rounded-2xl border border-white/10 bg-[#12141A] p-5 sm:grid-cols-3" data-testid="coupon-form">
        <input className={input} value={f.code} onChange={set("code")} placeholder="Codice (vuoto = automatico)" data-testid="coupon-code" />
        <input className={input} required type="number" step="0.01" min="0.01" value={f.value} onChange={set("value")} placeholder="Valore € *" data-testid="coupon-value" />
        <input className={input} value={f.order_number} onChange={set("order_number")} placeholder="Ordine originario" data-testid="coupon-order" />
        <input className={input} type="email" value={f.customer_email} onChange={set("customer_email")} placeholder="Email cliente" data-testid="coupon-email" />
        <label className="text-xs text-slate-400">Scadenza (facoltativa)<input className={input} type="date" value={f.expires_at} onChange={set("expires_at")} data-testid="coupon-expiry" /></label>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={f.partial_use} onChange={set("partial_use")} data-testid="coupon-partial" />Utilizzo parziale consentito</label>
        <textarea className={input + " h-auto py-2 sm:col-span-3"} rows={2} value={f.conditions} onChange={set("conditions")} placeholder="Condizioni di utilizzo" data-testid="coupon-conditions" />
        <button className="h-10 rounded-full bg-[#0066FF] text-sm font-medium sm:col-span-3 sm:w-48" data-testid="coupon-create-btn">Crea coupon</button>
      </form>
      <div className="mt-8 space-y-3">
        {list.map((c) => (
          <div key={c.id} className="flex flex-wrap items-center gap-3 rounded-2xl border border-white/10 bg-[#12141A] p-4 text-sm" data-testid={`coupon-row-${c.code}`}>
            <span className="font-mono font-semibold">{c.code}</span>
            <span className={`rounded-full px-2 py-0.5 text-xs ${BADGE[c.status]}`} data-testid={`coupon-status-${c.code}`}>{c.status}</span>
            <span>{eur(c.balance)} / {eur(c.value)}</span>
            <span className="text-slate-400">{c.order_number && `Ordine ${c.order_number} · `}{c.customer_email}{c.expires_at && ` · scade ${c.expires_at.slice(0, 10)}`}{c.partial_use ? " · parziale" : ""}</span>
            <span className="ml-auto flex gap-2">
              <button onClick={() => act(() => api.post(`/admin/coupons/${c.id}/send`), "Email inviata")} className="rounded-full border border-white/15 px-3 py-1.5 text-xs hover:border-[#0066FF]" data-testid={`coupon-send-${c.code}`}>{c.sent_at ? "Reinvia email" : "Invia email"}</button>
              <button onClick={() => act(() => api.patch(`/admin/coupons/${c.id}`, { active: !c.active }), "Aggiornato")} className="rounded-full border border-white/15 px-3 py-1.5 text-xs" data-testid={`coupon-toggle-${c.code}`}>{c.active ? "Disattiva" : "Riattiva"}</button>
            </span>
            {c.uses?.length > 0 && <p className="w-full text-xs text-slate-500">Utilizzi: {c.uses.map((u) => `${u.order} ${eur(u.amount)} (${u.state})`).join(" · ")}</p>}
          </div>
        ))}
        {!list.length && <p className="text-sm text-slate-500">Nessun coupon.</p>}
      </div>
    </div>
  );
}
